import { Box, Flex } from "@chakra-ui/react";
import { DroppableProps } from "../../types";
import PhotoBlackboardIcon from "components/icon/PhotoBlackboardIcon";

const ImageHasBlackboardDroppable: React.FC<DroppableProps> = ({
  isDragging,
}) => {
  return (
    <Box>
      <PhotoBlackboardIcon />
      {isDragging && (
        <Flex position={"relative"} w="100%" h="100%">
          <Flex
            position={"absolute"}
            top={"100%"}
            left="0"
            p="0.5rem 0"
            alignItems={"center"}
            whiteSpace={"nowrap"}
          >
            <PhotoBlackboardIcon w={"3rem"} h="3rem" />
            計器撮影写真
          </Flex>
        </Flex>
      )}
    </Box>
  );
};

export default ImageHasBlackboardDroppable;
